import React from 'react';
import {AGENTS, TEAM} from '../../consts/tables';
import Dropdown from "../Dropdown/Dropdown";
import PropTypes from "prop-types";
import {getData} from "../../requests/CRUD";

const cloneDeep = require('lodash.clonedeep');
const limit = 1000;

class SelectAgentAll extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            items: [],
        };
    }

    componentDidMount() {
        this.fetch(0);
    }

    fetch(offset) {
        const optionsOA = {
            limit: {
                count: limit,
                offset: offset * limit,
            },
            column: [
                'ARCIMEDES_ROW_ID',
                'FIRST_NAME',
                'LAST_NAME',
                'FIRM'
            ],
            filter: [{
                code: 'FIRST_NAME',
                text: '',
                type: 'notNull',
            }, {
                code: 'DELETED',
                text: '',
                type: 'null',
            }],
            filterType: 'and',
            order: [{
                code: 'FIRST_NAME',
                type: 'asc',
            }, {
                code: 'LAST_NAME',
                type: 'asc',
            }],
        };

        const optionsTeam = {
            limit: {
                count: 1000,
                offset: 0,
            },
            column: [
                'ARCIMEDES_ROW_ID',
                'FIRST_NAME',
                'LAST_NAME',
                'DELETED',
            ],
            filter: [{
                code: 'FIRST_NAME',
                text: '',
                type: 'notNull',
            }, {
                code: 'LAST_NAME',
                text: '',
                type: 'notNull',
            }],
            filterType: 'and',
            order: [{
                code: 'FIRST_NAME',
                type: 'asc',
            }, {
                code: 'LAST_NAME',
                type: 'asc',
            }],
        };

        const requests = [
            getData({tableCode: AGENTS, options: optionsOA})
        ];
        if (offset === 0)
            requests.push(getData({tableCode: TEAM, options: optionsTeam}));

        Promise.all(requests).then(res => {

            this.setState(prevState => {
                let team = [];
                let items = prevState.items;

                if (offset === 0) {
                    team = res[1].data.filter(x => x.FIRST_NAME && x.LAST_NAME);
                    const inactive = team && team.filter(x => x.DELETED === 'y') || [];
                    const active = team && team.filter(x => x.DELETED !== 'y') || [];
                    team = [...active, ...inactive];

                    team = team.map(el => {
                        el.groupedBy = el.DELETED !== 'y' ? 'active' : 'inactive';
                        return el;
                    });
                    items = items.concat(team);
                }
                const outsideAgents = res[0].data.map(el => {
                    el.groupedBy = 'oa';
                    return el;
                });
                items = items.concat(outsideAgents);

                return {
                    items,
                };
            });
            if (res[0].data.length >= limit) {
                this.fetch(++offset);
            }
        });
    }

    componentWillReceiveProps(nextProps) {
        if (this.props.newAgent !== nextProps.newAgent) {
            const items = cloneDeep(this.state.items);
            items.push(nextProps.newAgent);
            this.setState({items});
        }
    }

    render() {
        const { items } = this.state;
        const {
            theme,
            value,
            valueKey,
            label,
            disabled,
            data,
            withAddNew,
            handleParentChange,
            viewMode,
            addNewItem,
            deleted,
            isFromProperty,
            typeKey,
            ...rest,
        } = this.props;

        return (
            <Dropdown theme={theme}
                      optionsType='agent-all'
                      optionKey='ARCIMEDES_ROW_ID'
                      typeKey={typeKey}
                      typeValue={data && data[typeKey]}
                      options={items}
                      value={value}
                      valueKey={valueKey}
                      label={label}
                      disabled={!items || disabled}
                      data={data}
                      handleParentChange={handleParentChange}
                      withAddNew={withAddNew}
                      viewMode={viewMode}
                      deleted={deleted}
                      addNewItem={addNewItem}
                      isFromProperty={isFromProperty}
                      groupBy
                      {...rest}
            />
        )
    }
}

SelectAgentAll.propTypes = {
    theme: PropTypes.oneOf(['default', 'white', 'dark']),
    value: PropTypes.string,
    valueKey: PropTypes.string.isRequired,
    label: PropTypes.string,
    disabled: PropTypes.bool,
    data: PropTypes.object,
    withAddNew: PropTypes.bool,
    handleParentChange: PropTypes.func.isRequired,
    viewMode: PropTypes.bool,
    addNewItem: PropTypes.func,
    deleted: PropTypes.bool,
    isFromProperty: PropTypes.bool,
    typeKey: PropTypes.string,
};

export default SelectAgentAll;
